export const UPLOAD_FILE_TYPES = {
  VALNAV_CONSTANTS: "ValnavConstants",
  VALNAV_DECLINE: "ValnavDecline",
  MOSAIC_DECLINE: "MosaicDecline",
  FORECAST_ARRAY: "ForecastArray",
  WELL_DATA_UPLOAD: "WellDataUpload",
  HARMONY_DECLINE: "HarmonyDecline"
};

export type UploadFileType = (typeof UPLOAD_FILE_TYPES)[keyof typeof UPLOAD_FILE_TYPES];

/**
 * Response from the detect-products endpoint
 */
export interface DetectProductsResponse {
  fileType: UploadFileType;
  products: string[];
  defaultPrimaryProduct: string;
  warnings: string[];
}

/**
 * Mapping for well data upload - maps source column to target field
 */
export interface WellDataColumnMapping {
  sourceColumn: string; // Column header from Excel file
  targetField: string; // Field property (e.g., "Well_Design.HzLength_m", "Frac_Data.FluidTotal_m3")
}

/**
 * Response from the upload-well-data endpoint
 */
export interface WellDataUploadResponse {
  updated: number;
  skipped: number;
}
